export default __webpack_public_path__ + "static/media/Sun.e76b74e0.jpg";